import Vue from "vue";
import { mapGetters } from "vuex";
import { LoadingSpinner, PaginationText } from "@/components";
import { paginationMixin } from "@/components/mixins";
import { ErrorLogService } from "@/services/ErrorLogService";
import { ResourceLibraryService } from "@/services/ResourceLibraryService";
import { stringHelper } from "@/components/mixins/stringHelper";
import { MediaService } from "@/services/";
import { controlsHelper } from "@/components/mixins/commonControlsHelper";
import { constants } from "@/const";

export default Vue.extend({
  name: "ResourceLibrary",
  components: {
    LoadingSpinner,
    PaginationText
  },
  mixins: [paginationMixin, stringHelper, controlsHelper],
  data() {
    return {
      searchInput: '',
      searchText: '',
      resourceLibraryLoading: true,
      searchResults: [],
      allResults: [],
      selectedResultsPerPage: 10,
      currentPageNumber: 1,
      resultsPerPage: constants.RESULTS_PER_PAGE,
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "getContentItem",
      "activeAccountId",
      "McfCostCenterId",
      "audienceIds"
    ]),
    paginatedResults() {
      const start = (this.currentPageNumber - 1) * this.selectedResultsPerPage;
      const end = start + this.selectedResultsPerPage;
      return this.searchResults.slice(start, end);
    }
  },
  created() {
    this.loadResourceLibrary();
  },
  methods: {
    clearSearchState() {
      this.searchInput = '';
      this.searchText = '';
    },

    applyFilters() {
      this.currentPageNumber = 1;
      this.searchResults = this.allResults;
    },

    clearAllFilters() {
      this.clearSearchState();
      this.loadResourceLibrary();
    },

    downloadLink(fileId: string): string {
      return MediaService.getMediaUrl(fileId);
    },

    onSearch() {
      this.loadResourceLibrary(this.searchInput.trim());
    },

    loadResourceLibrary(searchTerm = ""): Promise<any[]> {
      this.resourceLibraryLoading = true;
      const params = {
        CostCenterId: this.McfCostCenterId,
        AccountId: this.activeAccountId,
        UserId: this.user?.UserId,
        UserAudiences: this.audienceIds,
        SearchTerm: searchTerm
      };

      return ResourceLibraryService.DocumentSearch(params)
        .then(results => {
          this.allResults = results;
          
          // Update search state
          this.searchText = searchTerm;
          this.searchInput = searchTerm;
          
          this.applyFilters();
          return results;
        })
        .catch(err => {
          ErrorLogService.LogException(err);
          return [];
        })
        .finally(() => {
          this.resourceLibraryLoading = false;
        });
    },

    resultsPerPageSelected() {
      this.currentPageNumber = 1;
      this.$emit("resultsPerPageChanged", this.selectedResultsPerPage);
    }
  }
});